export const isNumber = (item) => {
    return typeof item === 'string' || (typeof item === 'number' && isFinite(item));
};
export const isString = (item) => {
    return typeof item === 'string';
};
export const isNumberOrString = (item) => {
    return isString(item) || isNumber(item);
};
export const isArray = (item) => {
    return Array.isArray(item);
};
export const isObject = (item) => {
    return typeof item === 'object' && item !== null;
};
//# sourceMappingURL=baseAssert.js.map